import { IconButton, Tab, Tabs } from '@material-ui/core';
import React from 'react';

import { Close, ContentCopy } from '@mui/icons-material';
import { Container } from './TabUi.styles';
import { paleGrey, white } from '../../../helpers/constants/colors.constants';

function TabsUiComponent({
  items, containerBackground = paleGrey, tabSelectedBackground = white, onCopiarNroProcesso = null, onFecharAbaProcesso = null, ...props
}) {
  return (
    <Container backgroundColor={containerBackground} tabSelectedBackground={tabSelectedBackground}>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        {...props}
      >
        {items.map(item => (
          <Tab
            key={item.name}
            id={item.name}
            label={(
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>
                  {item.name}
                  {onCopiarNroProcesso && (
                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); onCopiarNroProcesso(item.name); }} style={{ marginLeft: 8 }}>
                    <ContentCopy fontSize="small" />
                  </IconButton>
                  )}

                  {onFecharAbaProcesso && (
                  <IconButton
                    size="small"
                    disabled={items.length < 2}
                    onClick={(e) => { e.stopPropagation(); onFecharAbaProcesso(e, item.name); }}
                    style={{ marginLeft: 8 }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                  )}
                </span>
              </div>
            )}
            {...item.props}
          />
        ))}
      </Tabs>
    </Container>
  );
}

export const TabsUi = React.memo(TabsUiComponent);
